import SvgWifi from "@assets/images/SvgWifi";

import "./styles/networkStatus.scss";

export default function NetworkStatus() {
  return (
    <div className="network-status">
      <SvgWifi />
    </div>
  );
}
